import Axios from "axios";
import { authorizationHeader } from "./apiUtils";
import {
  ProductInterface,
  UpsertProduct,
  UpsertProductPayload,
} from "../models/products";

const routes = {
  products: "/api/products",
  product: "/api/products/{stockNumber}",
  import: "/api/products/import",
  export: "/api/products/export",
  Diamondsimport: "/api/diamonds/import",
};

const getAll = async (): Promise<ProductInterface[]> => {
  const route = `${routes.products}?type=all`;
  const result = await Axios.get<ProductInterface[]>(route, {
    headers: authorizationHeader(),
  });
  return result.data;
};

const getSingleProduct = async (stockNumber: string): Promise<ProductInterface> => {
  const route = `${routes.products}/${stockNumber}`;
  const result = await Axios.get<ProductInterface>(route, {
    headers: authorizationHeader(),
  });
  return result.data;
};

const addProduct = async (payload: UpsertProductPayload) => {
  try {
 
    const merged: UpsertProduct = {
      id: 0,
      parcelName: "",
      quantity: 1,
      status: "Available",
      cost: 0,
      measurments: "",
      title: "",
      ringSize: 0,
      repair: 0,
      return: 0,
      certPrice: 0,
      totalPrice: 0,
      labCertificate: "",
      certNum: "",
      type: "",
      subType: "",
      material: "",
      karatGold: "",
      colorOfGold: "",
      weight: 0,
      mainStoneType: "",
      cutMainStone: "",
      numberOfMainStones: 0,
      caratMainStone: 0,
      colorMainStone: "",
      clarityMainStone: "",
      sideStoneType: "",
      cutSideStone: "",
      numberOfSideStones: 0,
      caratOfSideStone: 0,
      sideStoneColor: "",
      sideStoneClarity: "",
      secondSideStoneType: "",
      secondCutSideStone: "",
      secondNumberOfSideStones: 0,
      secondCaratOfSideStone: 0,
      secondSideStoneColor: "",
      secondSideStoneClarity: "",
      thirdSideStoneType: "",
      thirdCutSideStone: "",
      thirdNumberOfSideStones: 0,
      thirdCaratOfSideStone: 0,
      thirdSideStoneColor: "",
      thirdSideStoneClarity: "",
      forthSideStoneType: "",
      forthCutSideStone: "",
      forthNumberOfSideStones: 0,
      forthCaratOfSideStone: 0,
      forthSideStoneColor: "",
      forthSideStoneClarity: "",
      notes: "",
      brand: "",
      internalNotes: "",
      description: "",
      image1: "NoImage.jpg", 
      image2: "NoImage.jpg",
      image3: "NoImage.jpg",
      image4: "NoImage.jpg",
      image5: "NoImage.jpg",
      image6: "NoImage.jpg",
      image7: "NoImage.jpg",
      image8: "NoImage.jpg",
      image9: "NoImage.jpg",
      image10: "NoImage.jpg",
      video: "NoVideo.mp4",
      period: "",
      webPrice: "",
      soldFor: "",
      imageOrder: "image1,image2,image3,image4,image5,image6,image7,image8,image9,image10",
      descriptionHE: "",
      ...payload,
    };

    const result = await Axios.post(routes.products, merged, {
      headers: authorizationHeader(),
    });
    return result.data;
  } catch (error) {
    const err: any = error;
    throw new Error("Error posting the data: " + err.message);
  }
};


const edit = async (stockNumber: string, payload: UpsertProductPayload): Promise<ProductInterface> => {
  const route = routes.product.replace("{stockNumber}", stockNumber);
  const result = await Axios.patch(route, payload, {
    headers: authorizationHeader(),
  });
  return result.data; 
};

const delProduct = async (stockNumber: string) => {
  try {
    await Axios.delete(`${routes.products}/${stockNumber}`, {
      headers: authorizationHeader(),
    });
    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
};

const onExportCsv = async () => {
  try {
    const response = await Axios.get(routes.export, {
      headers: authorizationHeader(),
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'text/csv' });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'products.csv');

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    throw new Error("Error downloading file");
  }
};


const importCsv = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);

  await Axios.post(routes.import, formData, {
    headers: authorizationHeader(),
  });
};

const importDiamondsCsv = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);

  await Axios.post(routes.Diamondsimport, formData, {
    headers: authorizationHeader(),
  });
};

export { getAll, getSingleProduct, addProduct, edit, delProduct, importCsv, onExportCsv, importDiamondsCsv };
